(function () {
  'use strict';
  var sequence = 0;
  function boot(scope) {
    scope.querySelectorAll('[data-saracen-spare-parts]').forEach(function (panel) {
      if (panel.dataset.bound) return;
      panel.dataset.bound = 'true';
      var mount = panel.querySelector('[data-saracen-parts-mount]');
      panel.hidden = true;
      var skus;
      try {
        var product = panel.closest('[data-product-id]');
        var productJson = product && product.querySelector('.product-json');
        skus = productJson
          ? JSON.parse(productJson.textContent).variants.map(function (variant) { return variant.sku; })
          : JSON.parse(panel.dataset.skus || '[]');
      } catch (error) {
        console.warn('[Saracen spare parts] Could not read product SKUs:', error.message);
        return;
      }
      skus = Array.from(new Set(skus.map(function (sku) {
        return String(sku || '').trim();
      }).filter(Boolean)));
      if (!skus.length) return;
      Promise.all(skus.map(async function (sku) {
        try {
          var docs = await window.SpareParts.helpers.fetchJson('https://devapi.madisonb2b.co.uk/api/list', {
            q: sku, account: 'M9000', brand: 'saracen'
          });
          return { sku: sku, docs: Array.isArray(docs) ? docs : [] };
        } catch (error) {
          console.debug('[Saracen spare parts]', error.message);
          return { sku: sku, docs: [] };
        }
      })).then(async function (results) {
        if (!panel.isConnected) return;
        var docs = [];
        var seen = new Set();
        var matchedSku = '';
        results.forEach(function (result) {
          result.docs.forEach(function (doc) {
            var key = JSON.stringify([doc.doc_no, doc.content_type]);
            if (seen.has(key)) return;
            seen.add(key);
            docs.push(doc);
            if (!matchedSku) matchedSku = result.sku;
          });
        });
        if (!docs.length) return;
        var root = document.createElement('div');
        root.dataset.sparePartsRoot = 'saracen-parts-' + (++sequence);
        root.dataset.saracenManaged = 'true';
        root.dataset.account = 'M9000';
        root.dataset.brand = 'saracen';
        root.dataset.sku = matchedSku;
        mount.replaceChildren(root);
        panel.hidden = false;
        await window.SpareParts.bootRoot(root, { docs: docs });
      }).catch(function (error) {
        console.debug('[Saracen spare parts]', error.message);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
